import {
  Avatar,
  Flex,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  useColorMode,
  useMediaQuery,
} from '@chakra-ui/react';
import { ItemContent } from 'components/menu/ItemContent';
import { SidebarResponsive } from 'components/sidebar/Sidebar';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import userimage from '../../assets/img/auth/Default_profileoic.jpg';

import {
  MdLogout,
  MdNotifications,
  MdHelpOutline,
  MdSettings,
  MdPerson,
  MdBusiness,
  MdEditCalendar,
  MdOutlineLan,
  MdNoteAlt,
} from 'react-icons/md';

import routes from 'routes';
import Cookies from 'js-cookie';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import MainDashboard from 'views/admin/default';
import SuperadminDashboard from 'components/subscriptionManagement/SuperadminDashboard';

import TaskManagement from 'views/admin/taskManagement/components/TaskManagement';
import { decryptData } from 'utils/crypto';
import { setEmployeesDailyLogs, setEmployeesMonthlyLogs } from 'store/actions';
import UserAvatar from 'components/userAvatar';

export default function HeaderLinks(props) {
  const { secondary } = props;
  const location = useLocation();
  const { colorMode, toggleColorMode } = useColorMode();
  const navbarIcon = useColorModeValue('gray.400', 'white');
  const borderColor = useColorModeValue('#E6ECFA', 'rgba(135, 140, 189, 0.3)');
  const [image, setImage] = useState('');
  const [isDesktop] = useMediaQuery('(min-width: 769px)');
  const roleid = decryptData(Cookies.get('role_id'));
  console.log(roleid, 'roleid');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profileDataRedux = useSelector(
    (state) => state.Authentication.profiledata,
  );

  const routesLocal = JSON.parse(localStorage.getItem('accessModules') || '[]');
  const username = Cookies.get("username")
  const email = Cookies.get("email")

  const iconsMap = { MdNoteAlt };
  const componentsMap = { MainDashboard, TaskManagement };

  const routes = routesLocal.map((item) => ({
    ...item,
    icon: React.createElement(iconsMap[item.icon], {
      width: '20px',
      height: '20px',
      color: 'inherit',
    }),
    component: componentsMap[item.component],
  }));

  const logoutHandler = async () => {
    try {
      const response = await httpInjectorService.LogOut();
      if (response.status === 'success') {
        Cookies.remove('authUser');
        Cookies.remove('userRole');
        Cookies.remove('email');
        Cookies.remove('role_id');
        Cookies.remove('org_id');
        Cookies.remove('user_id');
         localStorage.removeItem('authUser');
      localStorage.removeItem('accessModules');
      localStorage.removeItem('has-seen-tour');
      localStorage.removeItem('has-seen-project-tour');

        navigate('/login');
      }
    } catch (err) {
      console.log(err);
    }
  };

  const updatePasswordHandler = () => {
    navigate('/login/forgotpassword');
  };

  const getData = async () => {
    try {
      const id = decryptData(Cookies.get('user_id'));
      if (!id) return;

      const response = await httpInjectorService.getProfiledetails(id);
      if (response.status === 'success') {
        const profileData = response.data[0];
        setImage(profileData.image_url);
      }
    } catch (error) {
      console.error('Error fetching profile data', error);
    }
  };

  // Automatic Logout Logic after 30mins
  useEffect(() => {
    let timeoutId;

    const handleActivity = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(logout, 1800000); // 30 minutes
    };

    const logout = async () => {
      try {
        const response = await httpInjectorService.LogOut();
        if (response.status === 'success') {
          // await deleteDeviceTokenOnLogout();
          Cookies.remove('authUser');
          Cookies.remove('userRole');
          Cookies.remove('email');
          Cookies.remove('role_id');
          Cookies.remove('org_id');
          Cookies.remove('user_id');
          navigate('/login');
        } else {
          console.log(response);
        }
      } catch (err) {
        console.log(err);
      }
    };

    // Add event listeners for user activity
    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keypress', handleActivity);
    window.addEventListener('click', handleActivity);
    window.addEventListener('scroll', handleActivity);

    // Start the timeout when the component mounts
    handleActivity();

    // Cleanup event listeners and timeout on unmount
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keypress', handleActivity);
      window.removeEventListener('click', handleActivity);
      window.removeEventListener('scroll', handleActivity);
    };
  }, [navigate]);

  useEffect(() => {
    getData();
  }, []);

  return (
    <Flex
      w="100%"
      h="56px"
      align="center"
      justify="flex-end"
      bg="transparent"
      px="16px"
      py="0"
      border="none"
      borderRadius="0"
      boxShadow="none"
      position="fixed"
      top="0"
      left="0"
      zIndex="1000"
    >
      <SidebarResponsive routes={routes} />

      <Icon
        as={MdNotifications}
        w="22px"
        h="22px"
        cursor="pointer"
        ml="3"
        color={navbarIcon}
      />
      <Icon
        as={MdHelpOutline}
        w="22px"
        h="22px"
        ml="3"
        cursor="pointer"
        color={navbarIcon}
      />
      <Icon
        as={MdSettings}
        w="22px"
        h="22px"
        cursor="pointer"
        ml="3"
        color={navbarIcon}
      />

      <Menu>
        <MenuButton p="0">
          <UserAvatar username={username} size={24} className="mx-3" />
        </MenuButton>

        <MenuList
          p="6px 0"
          border="none"
          boxShadow="0px 4px 12px rgba(0,0,0,0.18)"
          bg={colorMode === 'light' ? '#fff' : '#2C2F3A'}
          minW="260px"
          borderRadius="8px"
        >
          <Flex flexDirection="column" gap="4px">
            <Flex
              direction="column"
              align="center"
              justify="center"
              borderBottom={`1px solid ${borderColor}`}
              textAlign="center"
            >
              <UserAvatar username={username} size={50} />

              <Text mt="1px" fontWeight="600" fontSize="16px">
                {username}
              </Text>

              <Text mt="-5" fontSize="14px" color="gray.500">
                {email}
              </Text>
            </Flex>

           
            {roleid === 2 &&  (
              <MenuItem
                icon={<MdPerson />}
                onClick={() => navigate('/admin/user-management')}
              >
                User Management
              </MenuItem>
            )}

            <MenuItem icon={<MdEditCalendar />} onClick={updatePasswordHandler}>
              Update Password
            </MenuItem>
             {/* {roleid === 2 && (
              <MenuItem
                icon={<MdPerson />}
               
              >
                Subscription Management
              </MenuItem>
            )} */}

            <hr style={{ margin: '6px 0', borderColor: borderColor }} />

            <MenuItem icon={<MdLogout />} onClick={logoutHandler}>
              Log Out
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );
}

HeaderLinks.propTypes = {
  secondary: PropTypes.bool,
};
